interface IOrderItemTotalCostInBaseCurrencyParams {
  price: string
  currencyRate: number
  quantity: number
  shippingAmount: Nullable<string>
  taxAmount: Nullable<string>
  includeTaxAndShipping: boolean // remove this value when CHQ_34_ADD_AMZNPO_TAX_SHIP is removed
}

export const orderItemTotalCostInBaseCurrency = ({
  price,
  currencyRate,
  quantity,
  shippingAmount,
  taxAmount,
  includeTaxAndShipping,
}: IOrderItemTotalCostInBaseCurrencyParams) => {
  let total = parseFloat(price) * currencyRate * quantity

  if (includeTaxAndShipping) {
    const taxes = taxAmount ? parseFloat(taxAmount) : 0
    const shipping = shippingAmount ? parseFloat(shippingAmount) : 0
    total = total + taxes + shipping
  }

  return total
}
